import React from 'react';

interface AutocompleteFormatPLZProps {
  suchvorschlag?: any;
}

export const AutocompleteFormatPLZ = ({
  suchvorschlag,
}: AutocompleteFormatPLZProps) => {
  return (
    suchvorschlag && (
      <span>
        {suchvorschlag[`plz`]}, {suchvorschlag[`ortsname`]}
      </span>
    )
  );
};
